import { render, staticRenderFns } from "./Source.vue?vue&type=template&id=a7b36452&scoped=true&"
import script from "./Source.vue?vue&type=script&lang=js&"
export * from "./Source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b36452",
  null
  
)

export default component.exports